import React from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import { IconNameT } from "get-life-storybook-ts/lib/components/Icons/GlobalIcon";
import { IconSizeT } from "get-life-storybook-ts/lib/components/Icons/IconProps.interface";
import "./v3Nav.scss";

interface V3NavProps {
  logo?: IconNameT;
  logoSize?: IconSizeT;
  logoClassname?: string;
  secondaryLogo?: IconNameT;
  secondaryLogoClassname?: string;
  configLogo?: string | null;
  useConfigLogo?: boolean;
  phone?: string | null;
  onPhoneClick?: () => void;
}

const V3Nav: React.FC<V3NavProps> = ({
  logo,
  logoSize,
  logoClassname,
  secondaryLogo,
  secondaryLogoClassname,
  configLogo,
  useConfigLogo,
  phone,
  onPhoneClick,
}) => {
  const renderLogo = () => {
    if (useConfigLogo && configLogo) {
      return (
        <picture className="v3-nav__configLogo">
          <img src={configLogo} alt="" />
        </picture>
      );
    }
    if (!logo) return null;
    return (
      <span className={logoClassname}>
        <GlobalIcon iconName={logo} size={logoSize} />
      </span>
    );
  };

  return (
    <header className="v3-nav">
      <div className="v3-nav__inner">
        <div className="v3-nav__logo">
          {renderLogo()}
          {secondaryLogo && (
            <span className={secondaryLogoClassname}>
              <GlobalIcon iconName={secondaryLogo} />
            </span>
          )}
        </div>
        {phone && (
          <a
            className="v3-nav__phone"
            href={`tel:${phone.replace(/\s/g, "")}`}
            onClick={(e) => {
              if (onPhoneClick) {
                e.preventDefault();
                onPhoneClick();
              }
            }}
          >
            <GlobalIcon iconName="PhoneIcon" size="XS" color="#423EF4" />
            {phone}
          </a>
        )}
      </div>
    </header>
  );
};

export default V3Nav;
